import * as React from 'react';
import FinancialFilingDataGrid from './FinancialFilingDataGrid';

function TenQFilings({filings} :any) {
  return (
    <div className="col-lg-4 grid-margin stretch-card">
      <div className="card">
        <div className="card-body">
          <h4 className="card-title">10-Q Filings</h4>
          <p className="card-description">
            Select a 10-Q (Quarterly Report) to analyze and review with our AI assistant.
          </p>
          <div>
            { filings?.data['10-Q']?.length > 0  ?
              <FinancialFilingDataGrid
                data={filings.data['10-Q']}
              />
            : <p className="card-description">There are no 10-Q filings available</p> }
          </div>
        </div>
      </div>
    </div>
  );
}

export default TenQFilings;
